import { Link, useLocation } from "react-router-dom";
import Layout from "@/components/feature/Layout";

export default function NotFound() {
  const location = useLocation();

  return (
    <Layout>
      <div className="relative flex flex-col items-center justify-center min-h-[70vh] text-center px-4 pt-20">
        <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-100 select-none pointer-events-none z-0">
          404
        </h1>
        <div className="relative z-10">
          <div className="w-20 h-20 mx-auto mb-6 flex items-center justify-center rounded-full bg-background-100">
            <i className="ri-error-warning-line text-3xl text-foreground-400"></i>
          </div>
          <h1 className="text-xl md:text-2xl font-semibold text-foreground-900 mb-2">
            页面未找到
          </h1>
          <p className="text-sm text-foreground-500 font-mono mb-4">{location.pathname}</p>
          <p className="text-sm text-foreground-600 mb-6">
            您访问的页面不存在或已被移除，请检查网址是否正确。
          </p>
          <Link
            to="/"
            className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-6 py-2.5 rounded-md text-sm font-medium whitespace-nowrap transition-all duration-200"
          >
            <i className="ri-home-line"></i>
            返回首页
          </Link>
        </div>
      </div>
    </Layout>
  );
}